<ez-main-layout>
  <ez-banner>
    <span ngProjectAs="title">Willkommen</span>
    <span ngProjectAs="subtitle">Bitte verifizieren Sie sich mit Ihrem Zugangscode</span>
  </ez-banner>
  <h3>Ihr persönlicher Zugangscode</h3>
  <p>Bitte geben Sie im nachfolgenden Feld Ihren persönlichen Zugangscode aus dem Anschreiben ein.</p>
  <form class="form-body" [formGroup]="form" (ngSubmit)="onSubmit()">
    <input
      id="personalAccessToken"
      type="password"
      placeholder="Bitte Zugangscode eingeben"
      formControlName="personalAccessToken"
      [class.error]="errorMessage()"
    />
    @if (errorMessage(); as _message) {
      <span class="error-message">{{ _message }}</span>
    }
    <ez-button
      id="tokenSubmitButton"
      buttonType="submit"
      maxWidth="300px"
      [disabled]="!(form && form.valid)"
      [loading]="submitPersonalAccessTokenIsLoading()"
      label="Senden"
    ></ez-button>
  </form>
</ez-main-layout>
